module.exports = __webpack_public_path__ + "static/img/gonglv.60532260.png";